import React from 'react';
import { FormField, inputClass } from './FormField';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../../common/SafeIcon';

export const StepGuardian = ({ formData, onChange, errors, guardianKey, label }) => {
  const prefix = guardianKey;
  const set = (field) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    onChange({ ...formData, [`${prefix}${field}`]: value });
  };

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-brand-navy mb-1">{label}</h3>
        <p className="text-sm text-slate-500">
          {prefix === 'guardian1'
            ? 'The primary person designated to care for your minor children.'
            : 'A backup guardian if the primary guardian is unable to serve.'}
        </p>
      </div>

      <FormField label="Full Legal Name" error={errors[`${prefix}FullName`]} required>
        <input
          type="text"
          className={inputClass(errors[`${prefix}FullName`])}
          value={formData[`${prefix}FullName`] || ''}
          onChange={set('FullName')}
          placeholder="Guardian's full legal name"
        />
      </FormField>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField label="Relationship to Children" error={errors[`${prefix}Relationship`]} required>
          <input
            type="text"
            className={inputClass(errors[`${prefix}Relationship`])}
            value={formData[`${prefix}Relationship`] || ''}
            onChange={set('Relationship')}
            placeholder="e.g. Aunt, Godparent, Family Friend"
          />
        </FormField>

        <FormField label="Phone Number" error={errors[`${prefix}Phone`]} required>
          <input
            type="tel"
            className={inputClass(errors[`${prefix}Phone`])}
            value={formData[`${prefix}Phone`] || ''}
            onChange={set('Phone')}
            placeholder="(555) 000-0000"
          />
        </FormField>
      </div>

      <FormField label="Current Address" error={errors[`${prefix}Address`]} required>
        <textarea
          className={`${inputClass(errors[`${prefix}Address`])} min-h-[80px] resize-none`}
          value={formData[`${prefix}Address`] || ''}
          onChange={set('Address')}
          placeholder="Street address, city, state, ZIP code"
        />
      </FormField>

      <div className={`flex items-start gap-3 p-4 rounded-lg border ${errors[`${prefix}Accepts`] ? 'border-red-300 bg-red-50' : 'border-slate-200 bg-slate-50'}`}>
        <input
          type="checkbox"
          id={`${prefix}Accepts`}
          className="mt-1 h-4 w-4 rounded border-slate-300 text-brand-navy accent-slate-900 cursor-pointer"
          checked={!!formData[`${prefix}Accepts`]}
          onChange={set('Accepts')}
        />
        <label htmlFor={`${prefix}Accepts`} className="text-sm text-slate-700 cursor-pointer leading-relaxed">
          <span className="font-medium">I confirm that this guardian has been informed of and accepts responsibility</span>{' '}
          for the care and welfare of the named minor children under the conditions outlined in this document.
        </label>
      </div>
      {errors[`${prefix}Accepts`] && (
        <p className="text-xs text-red-600 -mt-3 flex items-center gap-1">
          <SafeIcon icon={FiIcons.FiAlertCircle} /> {errors[`${prefix}Accepts`]}
        </p>
      )}
    </div>
  );
};